import { Colors, useBreakpoint } from "@brg/ui"
import { FC, useMemo } from "react"
import { QueueCircleType, QueuePoint, QueueRate } from "../QueueLineNew/QueueLineNew"
import { BottomCircleText, QueueCircleWrapper, QueueUserCircle, TopCircleText } from "./styles"
import { QueueMode } from "../../QueueNew"
import { useSelector } from "react-redux"
import { tariffColors, tariffSaturated } from "../../const"
import { selectorOrder } from "../../../../../slices/OrderSlice";
import { LayoutConst } from 'core'
import { useTranslation } from "react-i18next"

interface QueueCircleNewProps {
    point: QueuePoint
    pos: string
    rate: QueueRate
    isCurrent: boolean
    sequenceInfo?: any
    isLastPoint: boolean
    onClick?: () => void
    zIndex?: number
    mode?: QueueMode
}

const emptyColor = {
    text: "",
    bg: ""
}

export const QueueCircleNew: FC<QueueCircleNewProps> = (props) => {
    const { t } = useTranslation();
    const { point, rate, zIndex, isCurrent, isLastPoint, onClick, pos, mode, sequenceInfo } = props
    const { activeTariff: orderTariff } = useSelector(selectorOrder)
    const activeTariff = sequenceInfo?.tariff || orderTariff
    const isMobile = useBreakpoint(LayoutConst.screen.s - 1)
    const defaultSize = isMobile ? 24 : 32;

    const tariffColor = ((activeTariff?.type !== undefined) && ((activeTariff?.type - 1) >= 0))
        ? tariffColors[activeTariff?.type - 1] : tariffColors[0]

    const pointTitle = useMemo(() => (
        mode === QueueMode.create ? point.number : (isLastPoint ? t(`card_constructor.queue_messages.end_point_text`, { count: point.number }) : 
        t(`card_constructor.queue_messages.start_point_text`)) )
    , [isLastPoint, mode, point, t])

    const calculateColor = () => {
        const color = emptyColor

        if (point.type === 'first') return {
            text: Colors.gal,
            bg: tariffColor || Colors.galBlack47,
        }

        color.text = isCurrent ? Colors.galBlack100 : Colors.galBlack47
        if (tariffColor) {
            color.bg = tariffColor
        }
        return color
    }

    if (point.type === QueueCircleType.user) return <QueueUserCircle bottomText={point.bottomInfo} pos={pos}>...</QueueUserCircle>

    const isDoubleCircle = [QueueCircleType.current, QueueCircleType.first].includes(point.type)
    return <>
        {
            isDoubleCircle &&
            <QueueCircleWrapper
                size={defaultSize}
                col={{
                    text: "",
                    bg: (point.type === QueueCircleType.current)
                        ? Colors.gal
                        : activeTariff?.type ? tariffSaturated[activeTariff?.type - 1] : tariffSaturated[0]
                }}
                isCurrent={isCurrent}
                zIndex={zIndex}
                pos={pos}
                point={point}
                onClick={onClick}
                title={point.title}
                border={(point.type === QueueCircleType.current) ? '1px solid #545453' : 'none'}
            >
                <QueueCircleWrapper
                    size={12}
                    col={{ text: "", bg: tariffColor || '' }}
                    isCurrent={isCurrent}
                    isStatic
                    zIndex={(zIndex || 100) + 1}
                    pos={pos}
                    point={point}
                >
                   {!isMobile && (
                    <TopCircleText size={defaultSize} {...mode === QueueMode.view && { isStartPoint: !isLastPoint}}>
                        {pointTitle}
                    </TopCircleText>
                   )}
                </QueueCircleWrapper>

                {isMobile && (
                    <TopCircleText size={defaultSize} {...mode === QueueMode.view && { isStartPoint: !isLastPoint}}>
                        {pointTitle}
                    </TopCircleText>
                )}
            </QueueCircleWrapper>
        }
        {
           !isDoubleCircle &&
            <QueueCircleWrapper
                size={defaultSize}
                col={calculateColor()}
                isCurrent={isCurrent}
                isLastPoint={isLastPoint}
                bottomText={point.bottomInfo}
                zIndex={zIndex}
                pos={pos}
                point={point}
                onClick={onClick}
                title={point.title}
            >
                <TopCircleText size={defaultSize} {...mode === QueueMode.view && { isStartPoint: !isLastPoint}}>
                    {pointTitle}
                </TopCircleText>
                <BottomCircleText size={defaultSize} isLast={isLastPoint} justify="flex-end" width='100%'>
                    {point.bottomInfo}
                </BottomCircleText>
            </QueueCircleWrapper>
        }
    </>
}
import { Colors, useBreakpoint } from "@brg/ui"
import { FC, useMemo } from "react"
import { QueueCircleType, QueuePoint, QueueRate } from "../QueueLineNew/QueueLineNew"
import { BottomCircleText, QueueCircleWrapper, QueueUserCircle, TopCircleText } from "./styles"
import { QueueMode } from "../../QueueNew"
import { useSelector } from "react-redux"
import { tariffColors, tariffSaturated } from "../../const"
import { selectorOrder } from "../../../../../slices/OrderSlice";
import { LayoutConst } from 'core'
import { useTranslation } from "react-i18next"

interface QueueCircleNewProps {
    point: QueuePoint
    pos: string
    rate: QueueRate
    isCurrent: boolean
    sequenceInfo?: any
    isLastPoint: boolean
    onClick?: () => void
    zIndex?: number
    mode?: QueueMode
}

const emptyColor = {
    text: "",
    bg: ""
}

export const QueueCircleNew: FC<QueueCircleNewProps> = (props) => {
    const { t } = useTranslation();
    const { point, rate, zIndex, isCurrent, isLastPoint, onClick, pos, mode, sequenceInfo } = props
    const { activeTariff: orderTariff } = useSelector(selectorOrder)
    const activeTariff = sequenceInfo?.tariff || orderTariff
    const isMobile = useBreakpoint(LayoutConst.screen.s - 1)
    const defaultSize = isMobile ? 24 : 32;

    const tariffColor = ((activeTariff?.type !== undefined) && ((activeTariff?.type - 1) >= 0))
        ? tariffColors[activeTariff?.type - 1] : tariffColors[0]

    const pointTitle = useMemo(() => (
        mode === QueueMode.create ? point.number : (isLastPoint ? t(`card_constructor.queue_messages.end_point_text`, { count: point.number }) : 
        t(`card_constructor.queue_messages.start_point_text`)) )
    , [isLastPoint, mode, point, t])

    const calculateColor = () => {
        const color = emptyColor

        if (point.type === 'first') return {
            text: Colors.gal,
            bg: tariffColor || Colors.galBlack47,
        }

        color.text = isCurrent ? Colors.galBlack100 : Colors.galBlack47
        if (tariffColor) {
            color.bg = tariffColor
        }
        return color
    }

    if (point.type === QueueCircleType.user) return <QueueUserCircle bottomText={point.bottomInfo} pos={pos}>...</QueueUserCircle>

    const isDoubleCircle = [QueueCircleType.current, QueueCircleType.first].includes(point.type)
    return <>
        {
            isDoubleCircle &&
            <QueueCircleWrapper
                size={defaultSize}
                col={{
                    text: "",
                    bg: (point.type === QueueCircleType.current)
                        ? Colors.gal
                        : activeTariff?.type ? tariffSaturated[activeTariff?.type - 1] : tariffSaturated[0]
                }}
                isCurrent={isCurrent}
                zIndex={zIndex}
                pos={pos}
                point={point}
                onClick={onClick}
                title={point.title}
                border={(point.type === QueueCircleType.current) ? '1px solid #545453' : 'none'}
            >
                <QueueCircleWrapper
                    size={12}
                    col={{ text: "", bg: tariffColor || '' }}
                    isCurrent={isCurrent}
                    isStatic
                    zIndex={(zIndex || 100) + 1}
                    pos={pos}
                    point={point}
                >
                   {!isMobile && (
                    <TopCircleText size={defaultSize} {...mode === QueueMode.view && { isStartPoint: !isLastPoint}}>
                        {pointTitle}
                    </TopCircleText>
                   )}
                </QueueCircleWrapper>

                {isMobile && (
                    <TopCircleText size={defaultSize} {...mode === QueueMode.view && { isStartPoint: !isLastPoint}}>
                        {pointTitle}
                    </TopCircleText>
                )}
            </QueueCircleWrapper>
        }
        {
           !isDoubleCircle &&
            <QueueCircleWrapper
                size={defaultSize}
                col={calculateColor()}
                isCurrent={isCurrent}
                isLastPoint={isLastPoint}
                bottomText={point.bottomInfo}
                zIndex={zIndex}
                pos={pos}
                point={point}
                onClick={onClick}
                title={point.title}
            >
                <TopCircleText size={defaultSize} {...mode === QueueMode.view && { isStartPoint: !isLastPoint}}>
                    {pointTitle}
                </TopCircleText>
                <BottomCircleText size={defaultSize} isLast={isLastPoint} justify="flex-end" width='100%'>
                    {point.bottomInfo}
                </BottomCircleText>
            </QueueCircleWrapper>
        }
    </>
}
